import { useEffect } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { isMobile } from "react-device-detect";
import {
  useEstimatePresetStore,
  useEstimateEditorStore,
  useFonts,
  EditorRoot,
  ProposalAppBar,
  EstimateStructureProvider,
} from "@tools";
import { AppContainer } from "@components";

export const PrinterView = observer(({
  useBorders,
}) => {
  const editorStore = useEstimateEditorStore();
  const presetStore = useEstimatePresetStore();
  const { loadFonts, unloadFonts } = useFonts();

  const { currentEstimateStructure } = editorStore;
  const { selectedPresetFont } = presetStore;

  useEffect(() => {
    if(selectedPresetFont)
      loadFonts([selectedPresetFont])

    return () => {
      unloadFonts();
    }
  }, [editorStore.currentVersionKey]);

  return (
    <EstimateStructureProvider value={currentEstimateStructure}>
      <ProposalAppBar isPdfPrinterView />
      <AppContainer
        isPdfPrinterView
        useViewportResizeObserver={isMobile}
      >
        <EditorRoot
          isProposal
          isPdfPrinterView
          noTurningOff
          noCommenting
          readOnly
          forceExpansionArrows
          showRowGroupBorders={useBorders}
          allowInteractions={false}
        />
      </AppContainer>
    </EstimateStructureProvider>
  );
});

PrinterView.propTypes = {
  useBorders: bool,
}
